import { Work } from "../../../types/work";
import { EntitySelectionProps } from "../EntitySelectionInput";
import EntitySelectionModal from "../../modals/EntitySelectionModal";
import useWorkQuery from "../../../hooks/query/useWorkQuery";
import useWorkLogic from "../../../hooks/logic/workLogic";

interface WorkSelectionModalProps extends EntitySelectionProps<Work> {
  systemLanguageType: Work["system_language_type"];
}

const WorkSelectionModal: React.FC<WorkSelectionModalProps> = ({
  open,
  initialSelectedEntity,
  onClose,
  handleEntitySelect,
  systemLanguageType,
  required,
}) => {
  const { useFetchAll } = useWorkQuery(systemLanguageType);
  const { languageBasedColumns } = useWorkLogic(systemLanguageType);
  const { data, isLoading, pagination, setPagination, errorMessage } =
    useFetchAll({
      enabled: open,
      filters: { system_language_type: systemLanguageType },
    });

  return (
    <EntitySelectionModal
      open={open}
      onClose={onClose}
      title="Select Works"
      columns={languageBasedColumns}
      data={data?.data || []}
      loading={isLoading}
      error={errorMessage}
      pagination={pagination}
      onPaginationChange={setPagination}
      onSelect={handleEntitySelect}
      totalRowCount={data?.total || 0}
      initialSelectedEntity={initialSelectedEntity}
      required={required}
    />
  );
};

const renderWorkSelection =
  (systemLanguageType: Work["system_language_type"]) =>
  (props: EntitySelectionProps<Work>) => (
    <WorkSelectionModal {...props} systemLanguageType={systemLanguageType} />
  );

export default renderWorkSelection;
